import { defineCopy } from '@/i18n'

// Headings with a highlighted phrase are split into pre / hl / post so word order can differ per language.
// List items are keyed to match the structural arrays (icons, flags) in Homekind.vue.
export default defineCopy('homekind', {
  id: {
    betaSubject: 'Daftar Beta Homekind',
    hero: {
      title: { pre: 'Satu aplikasi untuk ', hl: 'semua urusan rumah', post: '' },
      subtitle:
        'Keuangan, tagihan, agenda, daftar belanja, perawatan rumah, hingga obrolan keluarga, semuanya di satu tempat yang dipakai bersama seisi rumah. Dibuat khusus untuk keluarga Indonesia.',
      joinBeta: 'Gabung Beta Gratis',
      seeFeatures: 'Lihat Fitur',
      floatPaid: { title: 'Tagihan PLN lunas', sub: 'Rp489.000 · tercatat ke Kas' },
      floatService: { title: 'Servis AC 3 hari lagi', sub: 'Ditugaskan ke Pak Joko' },
    },
    problem: {
      badge: 'Kenapa Homekind?',
      title: { pre: 'Urusan rumah tersebar di ', hl: 'terlalu banyak tempat', post: '' },
      sub: 'Grup WhatsApp, aplikasi catatan, m-banking, spreadsheet, dan ingatan masing-masing. Akibatnya ada yang terlewat.',
      items: {
        chat: {
          title: 'Info tenggelam di grup chat',
          text: 'Jadwal, daftar belanja, dan pengingat hilang di antara ratusan pesan.',
        },
        bills: {
          title: 'Tagihan sering telat',
          text: 'PLN, PDAM, pajak kendaraan, PBB. Tidak ada yang merasa bertanggung jawab mengingatkan.',
        },
        money: {
          title: 'Uang bersama campur pribadi',
          text: 'Sulit tahu siapa sudah bayar apa, dan siapa masih berutang ke siapa.',
        },
        solo: {
          title: 'Aplikasi lain untuk satu orang',
          text: 'Kebanyakan aplikasi dibuat untuk individu, bukan untuk seisi rumah.',
        },
      },
    },
    features: {
      badge: 'Fitur',
      title: { pre: 'Semua yang dibutuhkan ', hl: 'rumah tangga modern', post: '' },
      sub: 'Setiap fitur berguna sendiri-sendiri, dan jadi lebih kuat karena saling terhubung.',
      soon: 'Segera hadir',
      items: {
        budget: { title: 'Kas & Anggaran', text: 'Tahu ke mana uang keluarga pergi, tanpa ribet.' },
        agenda: { title: 'Agenda Keluarga', text: 'Semua jadwal seisi rumah, dalam satu kalender.' },
        shopping: { title: 'Daftar Belanja & Catatan', text: 'Belanja bareng tanpa ada yang terlupa.' },
        maintenance: { title: 'Perawatan Rumah', text: 'Rumah terawat, jadwal servis tak pernah terlewat.' },
        debts: { title: 'Utang & Piutang', text: 'Pinjam-meminjam tetap jelas, hubungan tetap hangat.' },
        assets: { title: 'Aset Keluarga', text: 'Semua harta keluarga tercatat rapi di satu tempat.' },
        journal: { title: 'Jurnal Keluarga', text: 'Simpan momen berharga untuk dikenang bersama.' },
        bills: { title: 'Bayar Tagihan', text: 'Tagihan rumah lunas dalam hitungan detik.' },
        chat: { title: 'Chat Keluarga', text: 'Ngobrol dan beres-beres, di tempat yang sama.' },
        trips: { title: 'Trip & Liburan', text: 'Liburan dan mudik terencana tanpa drama.' },
        games: { title: 'Main Bareng', text: 'Keseruan kecil untuk malam keluarga.' },
        reminders: { title: 'Pengingat Pintar', text: 'Diingatkan di waktu yang pas, tanpa mengganggu.' },
      },
    },
    showcase: {
      badge: 'Tampilan Aplikasi',
      title: { pre: 'Intip ', hl: 'Homekind', post: '' },
      sub: 'Ramah dipakai satu tangan, dengan bahasa sehari-hari, bukan bahasa bank.',
      items: {
        budget: {
          title: 'Kas & Anggaran',
          tagline: 'Tahu ke mana uang pergi',
          description: 'Keuangan keluarga yang akhirnya terasa jelas dan tenang.',
          points: ['Uang bersama dan pribadi tetap rapi', 'Anggaran yang mudah dipantau', 'Laporan yang gampang dibaca'],
        },
        bills: {
          title: 'Bayar Tagihan',
          tagline: 'Tagihan rumah tanpa ribet',
          description: 'Bayar tagihan rumah semudah mengirim pesan.',
          points: ['Cepat dan transparan', 'Riwayat tersimpan otomatis', 'Diingatkan sebelum jatuh tempo'],
        },
        agenda: {
          title: 'Agenda Keluarga',
          tagline: 'Semua jadwal, satu kalender',
          description: 'Sekolah, arisan, les, sampai tugas rumah. Semua orang selalu tahu rencananya.',
          points: ['Satu kalender untuk seisi rumah', 'Tidak ada lagi jadwal bentrok', 'Terhubung dengan kalender favorit Anda'],
        },
        shopping: {
          title: 'Daftar Belanja',
          tagline: 'Belanja bareng, tanpa lupa',
          description: 'Semua orang bisa menambah, siapa pun bisa berangkat belanja.',
          points: ['Selalu sinkron, di mana pun', 'Tetap jalan meski sinyal lemah', 'Belanja selesai, catatan beres'],
        },
        maintenance: {
          title: 'Perawatan Rumah',
          tagline: 'Tidak ada lagi yang terlewat',
          description: 'Rumah terawat tanpa harus mengingat semuanya sendiri.',
          points: ['Siap pakai untuk rumah Indonesia', 'Bagi tugas dengan mudah', 'Kontak andalan selalu di tangan'],
        },
        chat: {
          title: 'Chat Keluarga',
          tagline: 'Ngobrol sambil beres',
          description: 'Obrolan keluarga yang bukan cuma ngobrol, tapi juga menyelesaikan urusan.',
          points: ['Urusan beres langsung dari chat', 'Ruang obrolan sesuai kebutuhan', 'Privasi tetap terjaga'],
        },
      },
    },
    connected: {
      badge: 'Saling Terhubung',
      title: { pre: 'Sekali ketuk, ', hl: 'semua ikut beres', post: '' },
      sub: 'Fitur-fitur Homekind saling bicara di belakang layar, jadi Anda cukup fokus ke keluarga.',
      items: {
        oneClick: { title: 'Satu klik, semua terupdate', text: 'Catat sekali, sisanya Homekind yang urus.' },
        noDouble: { title: 'Tanpa dobel input', text: 'Lupakan copy-paste antar aplikasi.' },
        everyone: { title: 'Semua orang selalu tahu', text: 'Seisi rumah melihat kabar terbaru, saat itu juga.' },
        auto: { title: 'Rumah yang berjalan sendiri', text: 'Pengingat dan catatan muncul tepat waktu, otomatis.' },
      },
    },
    privacy: {
      badge: 'Peran & Privasi',
      title: { pre: 'Dipakai bersama, ', hl: 'privasi tetap terjaga', post: '' },
      lead:
        'Setiap orang di rumah punya kebutuhan berbeda. Karena itu akses dibagi sesuai peran: semua dapat yang mereka perlukan, dan hal pribadi tetap pribadi.',
      roles: {
        manager: 'Pengelola rumah',
        core: 'Keluarga inti',
        kids: 'Si kecil',
        helpers: 'Pendukung & tamu',
      },
      visibility: {
        private: { name: 'Pribadi', desc: 'Cukup untuk Anda sendiri.' },
        chosen: { name: 'Pilih sendiri', desc: 'Bagikan ke yang Anda mau.' },
        household: { name: 'Seisi rumah', desc: 'Untuk dinikmati bersama.' },
      },
      trust: [
        'Homekind tidak pernah menyimpan uang Anda.',
        'Data terenkripsi dan terpisah antar rumah.',
        'Notifikasi tetap sopan di layar kunci.',
        'Dirancang dengan privasi sebagai prioritas.',
      ],
      illoLabel: 'Rumah dengan kamar pribadi, kamar bersama, dan ruang keluarga',
    },
    pricing: {
      badge: 'Harga',
      title: { pre: 'Satu langganan untuk ', hl: 'satu rumah', post: '' },
      sub: 'Bayar per rumah, bukan per orang. Mulai gratis, tingkatkan saat keluarga Anda bertambah.',
      ribbon: 'Paling lengkap',
      // {n} is replaced with the plan's seat count
      seats: { pre: 'Hingga ', strong: '{n} anggota', post: ' per rumah' },
      footnote: 'Satu harga untuk seisi rumah. Data Anda tetap aman meski langganan berakhir.',
      plans: {
        free: {
          name: 'Gratis',
          tagline: 'Untuk keluarga kecil yang baru mulai',
          price: 'Rp0',
          period: 'selamanya',
          note: 'Tanpa kartu kredit.',
          cta: 'Mulai Gratis',
        },
        plus: {
          name: 'Family Plus',
          tagline: 'Untuk keluarga besar dan seisi rumah',
          price: 'Rp199.000',
          period: '/ rumah / tahun',
          note: 'Setara ±Rp17 ribu per bulan untuk seisi rumah.',
          cta: 'Coba Gratis Selama Beta',
        },
      },
      planItems: {
        core: 'Fitur inti untuk urusan harian',
        sync: 'Sinkron antar perangkat',
        storage: 'Ruang simpan foto & dokumen',
        autopay: 'Bayar tagihan otomatis',
        premium: 'Fitur keluarga premium',
        allFree: 'Semua fitur paket Gratis',
        storageXl: 'Ruang simpan jauh lebih besar',
        history: 'Riwayat & ekspor tanpa batas',
        support: 'Prioritas dukungan',
      },
    },
    faq: {
      title: { pre: 'Pertanyaan yang Sering ', hl: 'Diajukan', post: '' },
      notFound: 'Belum menemukan jawabannya?',
      contactUs: 'Hubungi kami',
      items: [
        {
          question: 'Kapan Homekind bisa digunakan?',
          answer:
            'Homekind sedang memasuki Closed Beta bersama keluarga-keluarga pertama. Daftar sekarang untuk mendapat undangan, dan fitur akan hadir bertahap.',
        },
        {
          question: 'Apakah Homekind menyimpan uang saya?',
          answer: 'Tidak. Homekind hanya membantu mencatat. Setiap pembayaran diproses oleh mitra berlisensi.',
        },
        {
          question: 'Siapa yang bisa melihat pengeluaran pribadi saya?',
          answer: 'Hanya Anda, kecuali Anda sendiri yang memilih untuk membagikannya.',
        },
        {
          question: 'Bisakah asisten rumah tangga atau sopir ikut diundang?',
          answer: 'Bisa. Mereka hanya melihat hal yang memang mereka perlukan, urusan keluarga tetap privat.',
        },
        {
          question: 'Bisakah saya bergabung di lebih dari satu rumah?',
          answer: 'Bisa. Satu akun untuk rumah sendiri, rumah orang tua, atau keduanya.',
        },
        {
          question: 'Apa yang terjadi jika langganan Family Plus berakhir?',
          answer: 'Tidak ada data yang dihapus. Semua catatan keluarga Anda tetap aman.',
        },
      ],
    },
    cta: {
      badge: 'Kuota beta terbatas',
      title: { pre: 'Ajak seisi rumah mencoba ', hl: 'Homekind', post: '' },
      text:
        'Kami membuka Closed Beta untuk keluarga yang ingin ikut membentuk Homekind. Daftar sekarang dan dapatkan Family Plus gratis selama masa beta.',
      register: 'Daftar Beta',
      whatsapp: 'Tanya via WhatsApp',
    },
  },

  en: {
    betaSubject: 'Homekind Beta Sign-up',
    hero: {
      title: { pre: 'One app for ', hl: 'everything at home', post: '' },
      subtitle:
        'Money, bills, schedules, shopping lists, home upkeep, even family chat, all in one place the whole household shares. Made for Indonesian families.',
      joinBeta: 'Join the Free Beta',
      seeFeatures: 'See Features',
      floatPaid: { title: 'PLN bill paid', sub: 'Rp489,000 · logged to Budget' },
      floatService: { title: 'AC service in 3 days', sub: 'Assigned to Pak Joko' },
    },
    problem: {
      badge: 'Why Homekind?',
      title: { pre: 'Home life is scattered across ', hl: 'too many places', post: '' },
      sub: "WhatsApp groups, notes apps, mobile banking, spreadsheets, and everyone's memory. Things slip through the cracks.",
      items: {
        chat: {
          title: 'Info gets buried in group chats',
          text: 'Schedules, shopping lists, and reminders get lost among hundreds of messages.',
        },
        bills: {
          title: 'Bills keep running late',
          text: "Electricity, water, vehicle tax, property tax. Nobody feels it's their job to remind everyone.",
        },
        money: {
          title: 'Shared and personal money get mixed',
          text: 'Hard to tell who paid for what, and who still owes whom.',
        },
        solo: {
          title: 'Other apps are built for one person',
          text: 'Most apps are made for individuals, not for the whole household.',
        },
      },
    },
    features: {
      badge: 'Features',
      title: { pre: 'Everything a ', hl: 'modern household', post: ' needs' },
      sub: "Every feature is useful on its own, and stronger because they're all connected.",
      soon: 'Coming soon',
      items: {
        budget: { title: 'Money & Budget', text: 'Know where the family money goes, without the hassle.' },
        agenda: { title: 'Family Agenda', text: "Everyone's schedule, in one calendar." },
        shopping: { title: 'Shopping Lists & Notes', text: 'Shop together and forget nothing.' },
        maintenance: { title: 'Home Maintenance', text: 'A well-kept home, with no service date missed.' },
        debts: { title: 'Loans & IOUs', text: 'Lending stays clear, and relationships stay warm.' },
        assets: { title: 'Family Assets', text: "All the family's belongings, recorded neatly in one place." },
        journal: { title: 'Family Journal', text: 'Keep precious moments to look back on together.' },
        bills: { title: 'Bill Payments', text: 'Household bills paid in seconds.' },
        chat: { title: 'Family Chat', text: 'Chat and get things done, in the same place.' },
        trips: { title: 'Trips & Holidays', text: 'Holidays and trips home planned without the drama.' },
        games: { title: 'Play Together', text: 'Little bits of fun for family night.' },
        reminders: { title: 'Smart Reminders', text: 'Reminded at the right moment, never a nuisance.' },
      },
    },
    showcase: {
      badge: 'App Preview',
      title: { pre: 'A peek inside ', hl: 'Homekind', post: '' },
      sub: 'Easy to use with one hand, in everyday language, not bank-speak.',
      items: {
        budget: {
          title: 'Money & Budget',
          tagline: 'Know where the money goes',
          description: 'Family finances that finally feel clear and calm.',
          points: ['Shared and personal money kept tidy', 'A budget that is easy to track', 'Reports that are easy to read'],
        },
        bills: {
          title: 'Bill Payments',
          tagline: 'Household bills, no hassle',
          description: 'Pay household bills as easily as sending a message.',
          points: ['Fast and transparent', 'History saved automatically', 'Reminded before the due date'],
        },
        agenda: {
          title: 'Family Agenda',
          tagline: 'Every schedule, one calendar',
          description: 'School, social gatherings, lessons, and chores. Everyone always knows the plan.',
          points: ['One calendar for the whole household', 'No more clashing schedules', 'Connects to your favorite calendar'],
        },
        shopping: {
          title: 'Shopping List',
          tagline: 'Shop together, forget nothing',
          description: 'Anyone can add items, and anyone can go shopping.',
          points: ['Always in sync, wherever you are', 'Keeps working on a weak signal', 'Shopping done, list cleared'],
        },
        maintenance: {
          title: 'Home Maintenance',
          tagline: 'Nothing slips through anymore',
          description: 'A well-kept home without having to remember everything yourself.',
          points: ['Ready-made for Indonesian homes', 'Share out tasks easily', 'Trusted contacts always at hand'],
        },
        chat: {
          title: 'Family Chat',
          tagline: 'Chat and get things done',
          description: "Family chat that doesn't just talk, it gets things done.",
          points: ['Handle tasks right from the chat', 'Chat rooms for every need', 'Privacy stays protected'],
        },
      },
    },
    connected: {
      badge: 'All Connected',
      title: { pre: 'One tap, and ', hl: 'everything falls into place', post: '' },
      sub: "Homekind's features talk to each other behind the scenes, so you can focus on your family.",
      items: {
        oneClick: { title: 'One click, everything updated', text: 'Record it once, and Homekind handles the rest.' },
        noDouble: { title: 'No double entry', text: 'Forget copy-pasting between apps.' },
        everyone: { title: 'Everyone stays in the loop', text: 'The whole household sees the latest, right away.' },
        auto: { title: 'A home that runs itself', text: 'Reminders and records show up on time, automatically.' },
      },
    },
    privacy: {
      badge: 'Roles & Privacy',
      title: { pre: 'Shared by everyone, ', hl: 'private where it counts', post: '' },
      lead:
        "Everyone at home has different needs. That's why access is set by role: everyone gets what they need, and personal things stay personal.",
      roles: {
        manager: 'Household manager',
        core: 'Immediate family',
        kids: 'The little ones',
        helpers: 'Helpers & guests',
      },
      visibility: {
        private: { name: 'Private', desc: 'Just for you.' },
        chosen: { name: 'You choose', desc: 'Share with whoever you like.' },
        household: { name: 'Whole household', desc: 'For everyone to enjoy.' },
      },
      trust: [
        'Homekind never holds your money.',
        'Data is encrypted and kept separate for each home.',
        'Notifications stay discreet on the lock screen.',
        'Designed with privacy as a priority.',
      ],
      illoLabel: 'A house with private rooms, shared rooms, and a family room',
    },
    pricing: {
      badge: 'Pricing',
      title: { pre: 'One subscription for ', hl: 'one home', post: '' },
      sub: 'Pay per home, not per person. Start free, and upgrade as your family grows.',
      ribbon: 'Most complete',
      seats: { pre: 'Up to ', strong: '{n} members', post: ' per home' },
      footnote: 'One price for the whole household. Your data stays safe even if your subscription ends.',
      plans: {
        free: {
          name: 'Free',
          tagline: 'For small families just getting started',
          price: 'Rp0',
          period: 'forever',
          note: 'No credit card needed.',
          cta: 'Start Free',
        },
        plus: {
          name: 'Family Plus',
          tagline: 'For big families and the whole household',
          price: 'Rp199,000',
          period: '/ home / year',
          note: 'About Rp17k a month for the whole household.',
          cta: 'Try Free During the Beta',
        },
      },
      planItems: {
        core: 'Core features for everyday tasks',
        sync: 'Sync across devices',
        storage: 'Storage for photos & documents',
        autopay: 'Automatic bill payments',
        premium: 'Premium family features',
        allFree: 'Everything in Free',
        storageXl: 'Much more storage',
        history: 'Unlimited history & exports',
        support: 'Priority support',
      },
    },
    faq: {
      title: { pre: 'Frequently Asked ', hl: 'Questions', post: '' },
      notFound: "Can't find your answer?",
      contactUs: 'Contact us',
      items: [
        {
          question: 'When can I start using Homekind?',
          answer:
            'Homekind is entering Closed Beta with its first families. Sign up now to get an invite. Features will roll out gradually.',
        },
        {
          question: 'Does Homekind hold my money?',
          answer: 'No. Homekind only helps you keep records. Every payment is processed by licensed partners.',
        },
        {
          question: 'Who can see my personal spending?',
          answer: 'Only you, unless you choose to share it.',
        },
        {
          question: 'Can I invite a housekeeper or driver?',
          answer: 'Yes. They only see what they actually need, and family matters stay private.',
        },
        {
          question: 'Can I join more than one home?',
          answer: "Yes. One account for your own home, your parents' home, or both.",
        },
        {
          question: 'What happens if my Family Plus subscription ends?',
          answer: 'No data is deleted. All your family records stay safe.',
        },
      ],
    },
    cta: {
      badge: 'Limited beta spots',
      title: { pre: 'Get the whole household on ', hl: 'Homekind', post: '' },
      text:
        "We're opening a Closed Beta for families who want to help shape Homekind. Sign up now and get Family Plus free for the whole beta.",
      register: 'Join the Beta',
      whatsapp: 'Ask on WhatsApp',
    },
  },
})
